import { OrderbookGrouping } from '@drift/common';

export const ROW_HEIGHT = 22;

export const ORDERBOOK_DIVIDER_HEIGHT_MOBILE = 34;
export const ORDERBOOK_DIVIDER_HEIGHT_DESKTOP = 48;

export const ORDERBOOK_ROW_GAP_MOBILE = 2;
export const ORDERBOOK_ROW_GAP_DESKTOP = 4;

export const MAX_ORDERBOOK_DEPTH = 20;

export const ORDERBOOK_GROUPING_OPTIONS: OrderbookGrouping[] = [
	1, 10, 100, 500, 1000,
];
